export enum ChatRecipients {
  Agents = 'agents',
  All = 'all',
}
